import ApiError from "../../errors/ApiError";

export class LinkCustomerHostifyError extends ApiError {
  constructor() {
    super("Failed to link customer with Hostify");
  }
}
